/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import clsx from "clsx";
import { FC, useState } from "react";
import { Button } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { useDispatch } from "react-redux";
import { APP_URLs } from "../../../../constants/appURLs";
import { useAuth } from "../../../../pages/auth";

const isValidString = (val: any): val is string => {
  return (
    typeof val === "string" &&
    val.trim().length > 0 &&
    val.trim().toLowerCase() !== "undefined" &&
    val.trim().toLowerCase() !== "null"
  );
};

interface HeaderUserMenuProps {
  userProfile?: any;
}

const HeaderUserMenu: FC<HeaderUserMenuProps> = ({ userProfile }) => {
  const { currentUser } = useAuth();
  const dispatch = useDispatch();

  const logoutUser = async () => {
    // await dispatch(userLogout());
    localStorage.clear();
    window.location.reload();
  };

  const [profilePopUp, setProfilePopUp] = useState<boolean>(false);

  let userInfo: any = null;
  try {
    const userInfoJSON = localStorage.getItem("userInfo");
    if (userInfoJSON) {
      userInfo = JSON.parse(userInfoJSON);
    }
  } catch (e) {
    console.error("Failed to parse userInfo from localStorage", e);
  }

  const userProfileImg = isValidString(userProfile?.result?.profileUrl)
    ? userProfile.result.profileUrl
    : isValidString(userInfo?.profileUrl)
    ? userInfo.profileUrl
    : null;

  const userImage = userProfileImg
    ? `${APP_URLs?.mediaBaseURL}${userProfileImg}`
    : "";

  const firstName = isValidString(userProfile?.result?.firstName)
    ? userProfile.result.firstName.trim()
    : isValidString(userInfo?.firstName)
    ? userInfo.firstName.trim()
    : "";

  const lastName = isValidString(userProfile?.result?.lastName)
    ? userProfile.result.lastName.trim()
    : isValidString(userInfo?.lastName)
    ? userInfo.lastName.trim()
    : "";

  const roleOrName = isValidString(userInfo?.roleName)
    ? userInfo.roleName.trim()
    : isValidString(userInfo?.userName || userInfo?.username)
    ? (userInfo.userName || userInfo.username).trim()
    : isValidString(userInfo?.name)
    ? userInfo.name.trim()
    : "";

  let displayName = "User";
  if (firstName && lastName) {
    displayName = `${firstName} ${lastName}`;
  } else if (firstName) {
    displayName = firstName;
  } else if (lastName) {
    displayName = lastName;
  } else if (roleOrName) {
    displayName = roleOrName;
  }

  let initials = "U";
  if (firstName && lastName) {
    initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  } else if (firstName) {
    initials = firstName.charAt(0).toUpperCase();
  } else if (lastName) {
    initials = lastName.charAt(0).toUpperCase();
  } else if (roleOrName) {
    initials = roleOrName.charAt(0).toUpperCase();
  }

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
      data-kt-menu="true"
    >
      <div className="menu-item px-3">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="symbol symbol-50px me-5">
            <div
              className={clsx("cursor-pointer symbol symbol-circle", "")}
              data-kt-menu-trigger="{default: 'click'}"
              data-kt-menu-attach="parent"
              data-kt-menu-placement="bottom-end"
            >
              {userProfileImg ? (
                <img
                  src={`${userImage}`}
                  alt={displayName}
                  style={{
                    height: "50px",
                    width: "50px",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
              ) : (
                <div
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "50%",
                    backgroundColor: "#ccc",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textTransform: "uppercase",
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#333",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    userSelect: "none",
                  }}
                >
                  {initials}
                </div>
              )}
            </div>
          </div>

          <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-5">
              {displayName}
            </div>
            {userInfo?.email && (
              <span className="fw-bold text-muted text-hover-primary fs-7">
                {userInfo.email}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="separator my-2"></div>

      <div className="menu-item px-5" onClick={() => setProfilePopUp(true)}>
        <span className="menu-link px-5">My Profile</span>
      </div>

      {/* <div className="menu-item px-5">
        <a href="#" className="menu-link px-5">
          <span className="menu-text">My Projects</span>
          <span className="menu-badge">
            <span className="badge badge-light-danger badge-circle fw-bolder fs-7">
              3
            </span>
          </span>
        </a>
      </div> */}

      {/* <div
        className="menu-item px-5"
        data-kt-menu-trigger="hover"
        data-kt-menu-placement="left-start"
        data-kt-menu-flip="bottom"
      >
        <a href="#" className="menu-link px-5">
          <span className="menu-title">My Subscription</span>
          <span className="menu-arrow"></span>
        </a>

        <div className="menu-sub menu-sub-dropdown w-175px py-4">
          <div className="menu-item px-3">
            <a href="#" className="menu-link px-5">
              Referrals
            </a>
          </div>

          <div className="menu-item px-3">
            <a href="#" className="menu-link px-5">
              Billing
            </a>
          </div>

          <div className="menu-item px-3">
            <a href="#" className="menu-link px-5">
              Payments
            </a>
          </div>

          <div className="menu-item px-3">
            <a href="#" className="menu-link d-flex flex-stack px-5">
              Statements
              <i
                className="fas fa-exclamation-circle ms-2 fs-7"
                data-bs-toggle="tooltip"
                title="View your statements"
              ></i>
            </a>
          </div>

          <div className="separator my-2"></div>

          <div className="menu-item px-3">
            <div className="menu-content px-3">
              <label className="form-check form-switch form-check-custom form-check-solid">
                <input
                  className="form-check-input w-30px h-20px"
                  type="checkbox"
                  value="1"
                  defaultChecked={true}
                  name="notifications"
                />
                <span className="form-check-label text-muted fs-7">
                  Notifications
                </span>
              </label>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="menu-item px-5">
        <a href="#" className="menu-link px-5">
          My Statements
        </a>
      </div> */}

      <div className="separator my-2"></div>

      {/* <Languages /> */}

      {/* <div className="menu-item px-5 my-1">
        <Link to="/account/setting" className="menu-link px-5">
          Account Settings
        </Link>
      </div> */}

      <div className="menu-item px-5">
        <a onClick={logoutUser} className="menu-link px-5">
          Sign Out
        </a>
      </div>

      <Dialog
        open={profilePopUp}
        onClose={() => setProfilePopUp(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
          <h2>User Information</h2>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <div className="fv-row mb-8">
            <label className="form-label fw-bolder text-dark fs-6">
              First Name
            </label>
            <input
              placeholder="First name"
              type="text"
              autoComplete="off"
              className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
              value={userInfo?.firstName || ""}
              disabled
            />
          </div>
          <div className="fv-row mb-8">
            <label className="form-label fw-bolder text-dark fs-6">
              Last Name
            </label>
            <input
              placeholder="Last name"
              type="text"
              autoComplete="off"
              className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
              value={userInfo?.lastName || ""}
              disabled
            />
          </div>
          <div className="fv-row mb-8">
            <label className="form-label fw-bolder text-dark fs-6">Email</label>
            <input
              placeholder="Email"
              type="email"
              autoComplete="off"
              value={userInfo?.email || ""}
              disabled
              className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
            />
          </div>
          <div className="fv-row mb-8">
            <label className="form-label fw-bold">Mobile Number</label>
            <PhoneInput
              country={"us"}
              // value={formik.values.phoneNumber}
              inputStyle={{
                background: "#f9f9f9",
                border: "none",
              }}
              inputClass="form-control form-control-lg form-control-solid mb-3 mb-lg-0 w-100"
              value={userInfo?.phoneNumber || ""}
              disabled
            />
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => setProfilePopUp(false)}
            size="lg"
            variant="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export { HeaderUserMenu };
